import { render, staticRenderFns } from "./NewsDescription.vue?vue&type=template&id=235844c4&scoped=true&"
import script from "./NewsDescription.vue?vue&type=script&lang=js&"
export * from "./NewsDescription.vue?vue&type=script&lang=js&"
import style0 from "./NewsDescription.vue?vue&type=style&index=0&id=235844c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235844c4",
  null
  
)

export default component.exports